import type { OrganizationMember } from '@cartwhl/common/types';
import Avatar from '@cartwhl/ui/atoms/Avatar';
import GlobeIcon from '@cartwhl/ui/icons/GlobeIcon';

import {
  isAnonymousAssetCreator,
  resolvePeopleUserInfo,
} from '../assetLibraryFilters';

export type AssetLibraryCreatorAvatarProps = {
  userID: string;
  organizationMembers: readonly OrganizationMember[] | undefined;
  size?: number;
  className?: string;
};

export default function AssetLibraryCreatorAvatar({
  userID,
  organizationMembers,
  size = 7,
  className,
}: AssetLibraryCreatorAvatarProps) {
  if (isAnonymousAssetCreator(userID)) {
    return (
      <div
        className={`bg-gray-45 flex shrink-0 items-center justify-center rounded-full ${
          className ?? ''
        }`}
        style={{
          width: `${size / 4}rem`,
          height: `${size / 4}rem`,
        }}
        aria-label="API"
      >
        <GlobeIcon width={size * 2} height={size * 2} />
      </div>
    );
  }

  return (
    <Avatar
      size={size}
      className={className}
      userInfo={resolvePeopleUserInfo(userID, organizationMembers)}
    />
  );
}
